import { navigate } from "../lib/router";

/** Две половины приложения: свои настрои и тренажёры-проработки */
export function HomeTabs({ active }: { active: "sets" | "trainers" }) {
  const tab = (id: "sets" | "trainers", label: string) => (
    <button
      role="tab"
      aria-selected={active === id}
      className={active === id ? "home-tab on" : "home-tab"}
      onClick={() => navigate({ name: id === "sets" ? "library" : "trainers" }, { replace: true })}
    >
      {label}
    </button>
  );
  return (
    <nav className="home-tabs" role="tablist" aria-label="Разделы">
      {tab("trainers", "Тренажёры")}
      {tab("sets", "Настрои")}
    </nav>
  );
}
